import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, finalize, map } from 'rxjs';
import { initializeEditor } from 'src/app/utils/storage/editorConfig';
import { helper } from 'src/environments/helper';
import { CereriService } from '../../cereri.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { ToastrService } from 'ngx-toastr';

import { DocumentTemplateService } from 'src/app/platform/nomenclatoare/document-template/document-template.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeHtml } from '@angular/platform-browser';
import { StorageService } from 'src/app/utils/storage/storage.service';
import { environment } from 'src/environments/environment';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
@Component({
    selector: 'app-document-generabil',
    templateUrl: './document-generabil.component.html',
    styleUrls: ['./document-generabil.component.scss'],
})
export class DocumentGenerabilComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;

    token!: string;
    isLoading = false;
    uploading = false;

    helper = helper;
    editorConfig!: AngularEditorConfig;
    safeHtml!: SafeHtml;

    defaultChoiceParameter: { name: string; id: string } = {
        name: '-- Alegeți --',
        id: '-1',
    };

    user: any;

    form: FormGroup;

    templates$!: Observable<Generic[]>;
    template: any;

    destination = 'toPrimarie';

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<DocumentGenerabilComponent>,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private fb: FormBuilder,
        private storageService: StorageService,
        public toastr: ToastrService,
        private templateService: DocumentTemplateService
    ) {
        this.processToken();
        this.form = this.fb.group({
            cerere_id: [this.data.cerere.id_cerere, Validators.required],
            template_id: [-1],
            context: ['', Validators.required],
            context_cetatean: [''],
        });
        console.log(data);
    }

    ngOnInit() {
        this.loadTemplates();
        this.editorConfig = initializeEditor();

    }

    processUserDetails() {
        var self = this;
        const userObj = self.storageService.getObject(environment.config.userKey);
        userObj
            .then((val) => {
                self.user = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token: string) => {
            this.token = token;
            this.cereriService.setToken(token);
            this.processUserDetails();
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    loadTemplates() {
        this.isLoading = true;

        this.templates$ = this.templateService
            .getRecordsList(this.data.is_address)
            .pipe(
                map((results: any) => [this.defaultChoiceParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    onTemplateChange(templateId: number) {
        this.getTemplateById(templateId);
        this.destination = 'toPrimarie';
    }

    getTemplateById(templateId: number) {
        this.isLoading = true;
        this.templateService
            .templateByCerereId(templateId, this.data.cerere.id_cerere)
            .pipe(map((response: any) => response.data))
            .subscribe((requestData) => {
                console.log(requestData);
                this.isLoading = false;
                this.template = requestData;
                this.form.patchValue({
                    context: this.template.context,
                    context_cetatean: this.template.context_cetatean,
                });
            });
    }

    openToast(object: any) {
        const { type, message, title } = object;

        let options = this.toastr.toastrConfig;
        options.progressBar = true;
        options.preventDuplicates = true;
        options.closeButton = true;

        const inserted = this.toastr.show(
            message,
            title,
            options,
            options.iconClasses[type]
        );
    }

    onHttpError(res: any, showErrorsInToast: boolean = false) {
        if (res.errors && res.errors.message && res.errors.message.length > 0) {
            res.errors.message.forEach((msg: string) => {
                if (showErrorsInToast) {
                    this.openToast({
                        title: this.errorTitle,
                        message: msg,
                        type: this.errorType,
                    });
                } else {
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
        } else {
            let errorMessage =
                environment.config.customNotifications.generalMessages.error;
            this.notificationService.warningSwal(
                this.errorTitle,
                errorMessage,
                this.errorIcon
            );
        }
    }

    submitDocumentGenerabil() {
        this.isLoading = true;

        let doc_type;
        if (this.template.document_generabil_dual == false) {
            doc_type = 1;
        } else {
            doc_type = 2;
        }
        this.cereriService
            .generateDocument(
                this.data.cerere.id_cerere,
                this.form.value.template_id,
                { ...this.form.value, ...this.data.is_address, doc_type: doc_type }
            )
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    onDestinatieChange(event: MatButtonToggleChange) {
        this.destination = event.value;
    }
}
